import { render } from "./BaseCard.vue?vue&type=template&id=595a6b5e&scoped=true"
const script = {}

import "./BaseCard.vue?vue&type=style&index=0&id=595a6b5e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-595a6b5e"

export default script